import { html } from 'lit';

export default (o) => html`<div class="chat-image-container ${o.is_expanded ? 'is-expanded' : ''}"><img class="chat-image chat-image--modal" src="${o.src}" @click="${o.toggleExpand}" title="${o.is_expanded ? 'Click to minimize' : 'Click to enlarge'}"></div>`;

// <button type="button" class="chat-image-toggle" @click=${o.toggleExpand}>${o.is_expanded ? '−' : '+'}</button>
